import moment from 'jalali-moment';
import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Calendar, Grid, Image, Select, TextField } from '@iho-design-system/Loader';

/*
    - icon
*/
import CalendarSVG from '../../../assets/images/icons/calendar-blue.svg';
import CloseSVG from '../../../assets/images/icons/close.svg';

import { config } from '../../../api/apiConfig';

const Toolbar = ({ searchProps }) => {

    /*
        - defaultData
    */
    const type = localStorage.getItem('type');
    const [searchData, setSearchData] = React.useState({
        transType: '-1',
        docType: '2',
        startDate: '',
        endDate: ''
    });
    const [searchStartDate, setSearchStartDate] = React.useState('');
    const [searchEndDate, setSearchEndDate] = React.useState('');

    /*
        - searchHandler
    */
    const searchHandler = (key, value) => {
        if (key === 'transType') {
            setSearchData({
                ...searchData,
                transType: value
            });
        }
        if (key === 'docType') {
            setSearchData({
                ...searchData,
                docType: value
            });
        }
    }

    /*
        - advancedSearchProps
    */
    const search = () => {
        searchData.section = 'report';
         searchData.startDate = (searchStartDate !== '') ? moment.from(searchStartDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
         searchData.endDate = (searchEndDate !== '') ? moment.from(searchEndDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        searchProps(searchData);
    }

    /*
        - clearDate
    */
    const clearDate = (calendar) => {
        if (calendar === 'searchStartDate') {
            setSearchStartDate('');
        }
        if (calendar === 'searchEndDate') {
            setSearchEndDate('');
        }
    }

    /*
        - walletReportExport
    */
    const walletReportExport = async () => {

        let AccessToken = localStorage.getItem('AccessToken');
        searchData.section = 'report';
        searchData.startDate = searchStartDate !== '' ? moment.from(searchStartDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        searchData.endDate = searchEndDate !== '' ? moment.from(searchEndDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        let url = `${config.url}/api/mvc/export/WalletReportExport?TransType=${searchData.transType}&DocType=${searchData.docType}&StartDate=${searchData.startDate}&EndDate=${searchData.endDate}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${AccessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch the file');
            }

            const blob = await response.blob();

            // Create a blob URL
            const urlDownload = window.URL.createObjectURL(blob);

            // Create an anchor element for download
            const a = document.createElement('a');
            a.href = urlDownload;
            a.download = 'wallet-report.xlsx'; // Specify the desired file name
            document.body.appendChild(a); // Append the anchor to the DOM
            a.click(); // Trigger the click event
            document.body.removeChild(a); // Clean up the anchor element

            // Revoke the blob URL to free memory
            window.URL.revokeObjectURL(urlDownload);

        } catch (error) {
            console.error('Error while downloading the file:', error);
        }

    
}

    /*
        - toggleCalendar
    */
    const toggleCalendar = (event, calendar) => {
        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12 lg-2 md-2'>
                        <Select
                            onChange={(value) => searchHandler('transType', value)}
                            label='وضعیت تراکنش'
                            init={searchData.TransType}>
                            <Select.Item
                                value='-1'>
                                همه
                            </Select.Item>
                            <Select.Item
                                value='0'>
                                برداشت
                            </Select.Item>
                            <Select.Item
                                value='1'>
                                واریز
                            </Select.Item>
                        </Select>
                    </Grid.Item>
                    <Grid.Item
                        size='col-12 lg-2 md-2'>
                        <Select
                            onChange={(value) => searchHandler('docType', value)}
                            label='نوع تراکنش'
                            init={searchData.DocType}>
                            <Select.Item
                                value='2'>
                                کیف پول
                            </Select.Item>
                            {type === 'B2B' &&
                                <React.Fragment>
                                    <Select.Item
                                        value='4'>
                                        اعتبار
                                    </Select.Item>
                                    <Select.Item
                                        value='5'>
                                        شارژ اعضا
                                    </Select.Item>
                                </React.Fragment>
                            }
                        </Select>
                    </Grid.Item>
                    <Grid.Item
                        className={`position-relative`}
                        size='col-12 lg-2 md-4'>
                        <Box
                            onClick={(event) => toggleCalendar(event, 'reserveStartDateCalendar')}>
                            <TextField
                                variant='outlined'
                                label='از تاریخ'
                                value={searchStartDate}
                                placeholder='روز/ماه/سال'
                                ms={{
                                    'input': {
                                        paddingRight: '35px'
                                    }
                                }} />
                            <Image
                                className={`pointer position-absolute`}
                                src={CalendarSVG}
                                ms={{
                                    width: '16px',
                                    height: '16px',
                                    top: '47px',
                                    right: '20px'
                                }} />
                            {searchStartDate !== '' &&
                                <Image
                                    onClick={() => clearDate('searchStartDate')}
                                    className={`pointer position-absolute`}
                                    src={CloseSVG}
                                    ms={{
                                        width: '16px',
                                        height: '16px',
                                        top: '47px',
                                        left: '20px'
                                    }} />
                            }
                            <Box
                                className={`d-none reserveStartDateCalendar position-absolute`}
                                ms={{
                                    width: '320px',
                                    top: 'calc(75px + var(--sizing-xs))',
                                    zIndex: '1'
                                }}>
                                <Calendar
                                    onChange={(event) => setSearchStartDate(event)} />
                            </Box>
                        </Box>
                    </Grid.Item>
                    <Grid.Item
                        className={`position-relative`}
                        size='col-12 lg-2 md-4'>
                        <Box
                            onClick={(event) => toggleCalendar(event, 'reserveEndDateCalendar')}>
                            <TextField
                                variant='outlined'
                                label='تا تاریخ'
                                value={searchEndDate}
                                placeholder='روز/ماه/سال'
                                ms={{
                                    'input': {
                                        paddingRight: '35px'
                                    }
                                }} />
                            <Image
                                className={`pointer position-absolute`}
                                src={CalendarSVG}
                                ms={{
                                    width: '16px',
                                    height: '16px',
                                    top: '47px',
                                    right: '20px'
                                }} />
                            {searchEndDate !== '' &&
                                <Image
                                    onClick={() => clearDate('searchEndDate')}
                                    className={`pointer position-absolute`}
                                    src={CloseSVG}
                                    ms={{
                                        width: '16px',
                                        height: '16px',
                                        top: '47px',
                                        left: '20px'
                                    }} />
                            }
                            <Box
                                className={`d-none reserveEndDateCalendar position-absolute`}
                                ms={{
                                    width: '320px',
                                    top: 'calc(75px + var(--sizing-xs))',
                                    zIndex: '1'
                                }}>
                                <Calendar
                                    onChange={(event) => setSearchEndDate(event)} />
                            </Box>
                        </Box>
                    </Grid.Item>
                    <Grid.Item
                        className={`d-flex justify-content-end`}
                        size='col-12 lg-4'>
                        <Button
                            onClick={() => walletReportExport()}
                            variant='outlined'
                            color='primary'
                            ms={{
                                marginTop: '28px',
                                '@media(max-width:992px)': {
                                    marginTop: '0'
                                }
                            }}>
                            دانلود جدول
                        </Button>
                        <Box
                            className={`mx-xs`} />
                        <Button
                            onClick={search}
                            color='primary'
                            ms={{
                                marginTop: '28px',
                                '@media(max-width:992px)': {
                                    marginTop: '0',
                                }
                            }}>
                            جستجو
                        </Button>
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );

}

export default Toolbar;